export enum Fund {
  INDEX = "INDEX",
  PORTFOLIO = "PORTFOLIO",
}

export enum ControlPanelMetric {
  SCOPE_1_WACI = "scope_1_waci",
  SCOPE_1_2_WACI = "scope_1_2_waci",
  SCOPE_1_2_3_WACI = "scope_1_2_3_waci",
  SCOPE_1_CV = "scope_1_cv",
  SCOPE_1_2_CV = "scope_1_2_cv",
  SCOPE_1_2_3_CV = "scope_1_2_3_cv",
}
